/* eslint-disable max-len */
export const BASENAME = '/webcast';
export const WEBCASTS_URL = '/webcasts';
export const LEGACY_WEBCASTS_URL = `${BASENAME}/webcasts`;
export const REGISTRATION_URL = (eventId) => `${BASENAME}/registration/${eventId}`;
export const OVERVIEW_URL = (eventId) => `${BASENAME}/update/${eventId}`;
export const ARCHIVE_URL = (eventId) => `${BASENAME}/archive/${eventId}`;
export const LEGACY_ARCHIVE_URL = (eventId) => `${BASENAME}/archive/${eventId}`;
export const HOME_PAGE = `${BASENAME}/home`;
export const AI_CONTENT_URL = (eventId) => `${BASENAME}/aicontent/${eventId}`;

export const EMAIL_URL = (eventId) => `${BASENAME}/emails/${eventId}`;
export const UPLOAD_URL = (eventId) => `${BASENAME}/upload/${eventId}`;
export const CONSOLE_URL = (eventId) => `${BASENAME}/html5console/${eventId}`;
export const ADMIN_URL = (eventId) => `${BASENAME}/eventadmin/${eventId}`;
export const MULTI_REGISTRATION_URL = (eventId) => `${BASENAME}/groupregistration/${eventId}`;
export const MANAGE_REGISTRATION_URL = (eventId) => `${BASENAME}/managereg/${eventId}`;

// paths to be used with react-router functionality
export const CREATE_PATH = `${BASENAME}/create`;
export const CREATE_COPY_PATH = `${BASENAME}/create/:eventId`;
export const OVERVIEW_PATH = `${BASENAME}/update/:eventId`;
export const REG_PATH = `${BASENAME}/registration/:eventId`;
export const MANAGEREG_PATH = `${BASENAME}/managereg/:eventId`;
export const ARCHIVE_PATH = `${BASENAME}/archive/:eventId`;
export const CONSOLE_PATH = `${BASENAME}/html5console/:eventId`;
export const EVENTADMIN_PATH = `${BASENAME}/eventadmin/:eventId`;
export const CAPTIONLIST_PATH = `${BASENAME}/captionlist/:eventId`;
export const EVENTSERIES_PATH = `${BASENAME}/eventseries/:eventId`;
